import axios from "axios";
import { store as storeNotification } from "react-notifications-component";
import { INPUTS_SAVED, INPUTS_SAVING, INPUTS_SAVING_FAILED } from "./types";
export const saveInputsAction = (listdata) => (dispatch) => {
	dispatch({ type: INPUTS_SAVING });

	let formData = new FormData(); //formdata object
	console.log("InputSaveActions data=", listdata);

	var listItems = listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			if (response.error)
				return dispatch({
					type: INPUTS_SAVING_FAILED,
					payload: response.error,
				});
			dispatch({ type: INPUTS_SAVED, payload: response.data._id });
			storeNotification.addNotification({
				title: "input saving!",
				message: "Succefull saved",
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});

			console.log("response.data=", response.data);
		})
		.catch((error) => {
			console.log(error);
		});
};
